import { FC } from 'react';
import classNames from 'classnames';
import { getSysEnv } from '@/utils';
import styles from './index.module.scss';
interface Props {
  /**缺省图 */
  icon: string;
  /**缺省文案 */
  title: string;
}
export const Empty: FC<Props> = (props) => {
  const { icon, title } = props;
  /**判断系统环境 */
  const sysEnv = getSysEnv();
  return (
    <div
      className={classNames(
        styles.empty_container,
        sysEnv !== 'isDesktop' ? styles.empty_container_mobile : ''
      )}
    >
      <img src={icon} alt="缺省图" className={styles.empty_icon} />
      <p className={styles.empty_title}>{title}</p>
    </div>
  );
};
